import { createSelector } from 'reselect';
import { playerModalSelector } from './simple-selector';

export const PlayerModalDataSelector = createSelector(
    playerModalSelector,
    (playerModal) => playerModal.data
);
